import React, { Component } from 'react';
import { Card, CardBody, Row, Col } from "reactstrap";

//Import Charts
import ReactApexChart from 'react-apexcharts';
import "./dashboard.scss";

class SalesAnalytics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            series: [1, 1, 1, 1, 1],
            options: {
                labels: ["Booked", "Processing", "Under Discussion" ,"In Progress", "Completed"],
                plotOptions: {
                    pie: {
                        donut: {
                            size: '70%'
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false,
                },
                colors: ['#1cbb8c', '#eeb902','#58a5ff','#5664d2', '#ff3d60'],

            }
        }
    }   

    componentDidCatch(error) {
        // Changing the state to true
        // if some error occurs
        console.log(error)
      }

    componentDidUpdate(preProps){
    if (preProps.data !== this.props.data){
        this.loadData()

    }
    }

    componentDidMount(){
        this.loadData()
    }

    loadData(){

        let data =this.props.data
        let processing = data.processing?data.processing:0
        let discussion = data.discussion?data.discussion:0
        let booked = data.booked?data.booked:0
        let progress = data.progress?data.progress:0
        let completed = data.completed?data.completed:0
        if (data.itinerraries){
            processing = parseInt((processing/data.itinerraries)*100)
            discussion = parseInt((discussion/data.itinerraries)*100)
            booked = parseInt((booked/data.itinerraries)*100)
            progress = parseInt((progress/data.itinerraries)*100)
            completed = parseInt((completed/data.itinerraries)*100)
        }
        this.setState({series: [booked, processing, discussion, progress, completed]})

    }


    render() {
    
        return (
            <React.Fragment>
                <Card>
                    <CardBody>
                       
                        <h4 className="card-title mb-4">Tours Analytics</h4>

                        <div id="donut-chart" className="apex-charts">
                            <ReactApexChart options={this.state.options} series={this.state.series} type="donut" height="250" />
                        </div>

                        <Row>
                            <Col xs={2}>
                                <div className="text-center mt-4">
                                    <p className="mb-2 text-truncate"><i className="mdi mdi-circle text-success font-size-10 me-1"></i> Booked</p>
                                    <h5>{this.state.series[0]} %</h5>
                                </div>
                            </Col>
                            <Col xs={3}>
                                <div className="text-center mt-4">
                                    <p className="mb-2 text-truncate"><i className="mdi mdi-circle text-warning font-size-10 me-1"></i> Processing</p>
                                    <h5>{this.state.series[1]} %</h5>
                                </div>
                            </Col>
                            <Col xs={2}>
                                <div className="text-center mt-4">
                                    <p className="mb-2 text-truncate"><i className="mdi mdi-circle text-info font-size-10 me-1"></i> Under Discussion</p>
                                    <h5>{this.state.series[2]} %</h5>
                                </div>
                            </Col>
                            <Col xs={2}>
                                <div className="text-center mt-4">
                                    <p className="mb-2 text-truncate"><i className="mdi mdi-circle text-primary font-size-10 me-1"></i> In Progress</p>
                                    <h5>{this.state.series[3]} %</h5>
                                </div>
                            </Col>
                            <Col xs={3}>
                                <div className="text-center mt-4">
                                    <p className="mb-2 text-truncate"><i className="mdi mdi-circle text-danger font-size-10 me-1"></i> Completed</p>
                                    <h5>{this.state.series[4]} %</h5>
                                </div>
                            </Col>
                        </Row>
                        
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

export default SalesAnalytics;